export const environment = {
  production: true,
  baseUrl: 'https://api.novafoodies.eu/api/v1',
  mapTilerApiKey: '45GCjUDBerl81iutJjmS',
  maxSizeFiles: 5242880,
};
